import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
	Avatar,
	Breadcrumb,
	Button,
	Card,
	Col,
	Divider,
	Form,
	Image,
	Input,
	Layout,
	List,
	Modal,
	message,
	Pagination,
	QRCode,
	Row,
	Select,
	Spin,
	Typography,
	Upload,
} from "antd";
import ImgCrop from "antd-img-crop";
import downloadjs from "downloadjs";
import html2canvas from "html2canvas";
import React from "react";
import { FaXTwitter } from "react-icons/fa6";
import {
	IoCameraOutline,
	IoCheckmark,
	IoCloudUploadOutline,
	IoLinkOutline,
	IoLogoFacebook,
	IoLogoInstagram,
	IoLogoLinkedin,
	IoLogoWhatsapp,
	IoLogoYoutube,
	IoMailOutline,
	IoPencil,
	IoTrash,
} from "react-icons/io5";
import ReactInputMask from "react-input-mask";
import { Navigate } from "react-router-dom";
import logo from "../../assets/img/logo/jurisvip-transparente.png";
import TimelineComponent from "../../components/Timeline";
import {
	getToken,
	getUPLOADAPI,
	POST_API,
	POST_CATCH,
	setPath,
	titleWeb,
	verifyConfig,
} from "../../services/api";
// CONTROLLER
import PageLoad from "../Controller/PageLoad";

class AdminMeuPerfil extends React.Component {
	state = {
		_navigate: false,
		_loading: false,
		_screen: true,
		_dados: null,
		_params: window.location.href.split("/"),
		special: [],
		defaultValue: null,
		doc: false,
		// NOSSA EQUIPE
		_equipe_list: [],
		_equipe_form: null,
		_equipe_type: "",
		_equipe_modal: false,
		_equipe_search: "",
		_equipe_loading: false,
		_equipe_pagination: {
			current: 1,
			total: 0,
			limit: 3,
		},
		// CLIENTES
		_cliente_list: [],
		_cliente_form: null,
		_cliente_type: "",
		_cliente_modal: false,
		_cliente_search: "",
		_cliente_loading: false,
		_cliente_pagination: {
			current: 1,
			total: 0,
			limit: 3,
		},
		// PUBLICAÇÕES
		_publicacoes_list: [],
		_publicacoes_form: null,
		_publicacoes_type: "",
		_publicacoes_modal: false,
		_publicacoes_search: "",
		_publicacoes_loading: false,
		_publicacoes_pagination: {
			current: 1,
			total: 0,
			limit: 3,
		},
	};

	routes = [{ title: "Crie sua página aqui e divulgue seu escritório!" }];

	componentDidMount = () => {
		titleWeb("Meu Perfil");
		setPath("credential");
		this.onLoad();
		this.onView();
		this.onRenderDataEquipe();
		this.onRenderDataCliente();
		this.onRenderDataPublicacoes();
	};

	buscaCEP = async (val) => {
		const cep = String(val.target.value).replace("-", "");
		this.setState({ _screen: true });
		await fetch(`https://viacep.com.br/ws/${cep}/json/`)
			.then((rs) => rs.json())
			.then((res) => {
				if (res.erro) {
					message.warning("CEP inválido");
				} else {
					this.setState({
						defaultValue: {
							...this.state.defaultValue,
							STREET: res.logradouro,
							DISTRICT: res.bairro,
							CITY: res.localidade,
							STATE: res.uf,
							CEP: cep,
						},
					});
				}
			})
			.catch(() => POST_CATCH())
			.finally(() => this.setState({ _screen: false }));
	};

	// FUNCTIONS NOSSA EQUIPE
	openModalNossaEquipe = (type, record = null) => {
		this.setState({
			_equipe_modal: true,
			_equipe_type: type,
			_equipe_form: record,
		});
	};

	closeModalNossaEquipe = () => {
		this.setState({
			_equipe_modal: false,
			_equipe_type: "",
			_equipe_form: null,
		});
	};

	onSaveEquipe = (values) => {
		this.setState({ _equipe_loading: true });
		POST_API("/team/save.php", {
			token: getToken(),
			master: JSON.stringify(values),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
					this.setState({
						_equipe_form: null,
						_equipe_modal: false,
						_equipe_type: "",
					});
					this.onRenderDataEquipe();
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.setState({ _equipe_loading: false }));
	};

	onActionEquipe = (ID, type, title) => {
		const self = this;
		Modal.confirm({
			title,
			icon: <ExclamationCircleOutlined />,
			cancelText: "Não",
			okText: "Sim",
			onOk() {
				POST_API("/team/del.php", { token: getToken(), ID, type })
					.then((rs) => rs.json())
					.then((res) => {
						if (res.return) {
							message.success({ content: res.msg, key: "screen" });
							self.onRenderDataEquipe();
						} else {
							message.warning({ content: res.msg, key: "screen" });
						}
					})
					.catch(() => {
						POST_CATCH();
					})
					.finally(() => self.setState({ _equipe_loading: false }));
			},
		});
	};

	onRenderDataEquipe = () => {
		this.setState({ _equipe_loading: true });
		setTimeout(() => {
			POST_API("/team/search.php", {
				token: getToken(),
				pagination: JSON.stringify(this.state._equipe_pagination),
				search: this.state._equipe_search,
				type: "list",
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						this.setState({
							_equipe_list: res.data,
							_equipe_pagination: {
								...this.state._equipe_pagination,
								total: res.summary.QTDE,
							},
						});
					} else {
						message.error({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => POST_CATCH())
				.finally(() => this.setState({ _equipe_loading: false }));
		}, 500);
	};

	onPaginationChangeEquipe = (page, size) => {
		this.setState({
			_equipe_pagination: {
				...this.state._equipe_pagination,
				current: page,
				limit: size,
			},
		});
		this.onRenderDataEquipe();
	};

	onSearchChangeEquipe = (e) => {
		this.setState({
			_equipe_search: e.target.value,
		});
		this.onRenderDataEquipe();
	};

	// FUNCTIONS CLIENTES
	openModalCliente = (type, record = null) => {
		this.setState({
			_cliente_modal: true,
			_cliente_type: type,
			_cliente_form: record,
		});
	};

	closeModalCliente = () => {
		this.setState({
			_cliente_modal: false,
			_cliente_type: "",
			_cliente_form: null,
		});
	};

	onSaveCliente = (values) => {
		this.setState({ _cliente_loading: true });
		POST_API("/client_team/save.php", {
			token: getToken(),
			master: JSON.stringify(values),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
					this.setState({
						_cliente_form: null,
						_cliente_modal: false,
						_cliente_type: "",
					});
					this.onRenderDataCliente();
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.setState({ _cliente_loading: false }));
	};

	onActionCliente = (ID, type, title) => {
		const self = this;
		Modal.confirm({
			title,
			icon: <ExclamationCircleOutlined />,
			cancelText: "Não",
			okText: "Sim",
			onOk() {
				POST_API("/client_team/del.php", { token: getToken(), ID, type })
					.then((rs) => rs.json())
					.then((res) => {
						if (res.return) {
							message.success({ content: res.msg, key: "screen" });
							self.onRenderDataCliente();
						} else {
							message.warning({ content: res.msg, key: "screen" });
						}
					})
					.catch(() => {
						POST_CATCH();
					})
					.finally(() => self.setState({ _cliente_loading: false }));
			},
		});
	};

	onRenderDataCliente = () => {
		this.setState({ _cliente_loading: true });
		setTimeout(() => {
			POST_API("/client_team/search.php", {
				token: getToken(),
				pagination: JSON.stringify(this.state._cliente_pagination),
				search: this.state._cliente_search,
				type: "list",
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						this.setState({
							_cliente_list: res.data,
							_cliente_pagination: {
								...this.state._cliente_pagination,
								total: res.summary.QTDE,
							},
						});
					} else {
						message.error({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => POST_CATCH())
				.finally(() => this.setState({ _cliente_loading: false }));
		}, 500);
	};

	onPaginationChangeCliente = (page, size) => {
		this.setState({
			_cliente_pagination: {
				...this.state._cliente_pagination,
				current: page,
				limit: size,
			},
		});
		this.onRenderDataCliente();
	};

	onSearchChangeCliente = (e) => {
		this.setState({
			_cliente_search: e.target.value,
		});
		this.onRenderDataCliente();
	};

	// FUNCTIONS PUBLICAÇÕES
	openModalPublicacoes = (type, record = null) => {
		this.setState({
			_publicacoes_modal: true,
			_publicacoes_type: type,
			_publicacoes_form: record,
		});
	};

	closeModalPublicacoes = () => {
		this.setState({
			_publicacoes_modal: false,
			_publicacoes_type: "",
			_publicacoes_form: null,
		});
	};

	onSavePublicacoes = (values) => {
		this.setState({ _publicacoes_loading: true });
		POST_API("/timeline/save.php", {
			token: getToken(),
			master: JSON.stringify(values),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
					this.setState({
						_publicacoes_form: null,
						_publicacoes_modal: false,
						_publicacoes_type: "",
					});
					this.onRenderDataPublicacoes();
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.setState({ _publicacoes_loading: false }));
	};

	onActionPublicacoes = (ID, type, title) => {
		const self = this;
		Modal.confirm({
			title,
			icon: <ExclamationCircleOutlined />,
			cancelText: "Não",
			okText: "Sim",
			onOk() {
				POST_API("/timeline/del.php", { token: getToken(), ID, type })
					.then((rs) => rs.json())
					.then((res) => {
						if (res.return) {
							message.success({ content: res.msg, key: "screen" });
							self.onRenderDataPublicacoes();
						} else {
							message.warning({ content: res.msg, key: "screen" });
						}
					})
					.catch(() => {
						POST_CATCH();
					})
					.finally(() => self.setState({ _publicacoes_loading: false }));
			},
		});
	};

	onRenderDataPublicacoes = () => {
		this.setState({ _publicacoes_loading: true });
		setTimeout(() => {
			POST_API("/timeline/search.php", {
				token: getToken(),
				pagination: JSON.stringify(this.state._publicacoes_pagination),
				search: this.state._publicacoes_search,
				type: "list",
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						this.setState({
							_publicacoes_list: res.data,
							_publicacoes_pagination: {
								...this.state._publicacoes_pagination,
								total: res.summary.QTDE,
							},
						});
					} else {
						message.error({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => POST_CATCH())
				.finally(() => this.setState({ _publicacoes_loading: false }));
		}, 500);
	};
	onRenderDataPublicacoesLoad = () => {
		setTimeout(() => {
			POST_API("/timeline/search.php", {
				token: getToken(),
				pagination: JSON.stringify(this.state._publicacoes_pagination),
				search: this.state._publicacoes_search,
				type: "list",
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						this.setState({
							_publicacoes_list: res.data,
							_publicacoes_pagination: {
								...this.state._publicacoes_pagination,
								total: res.summary.QTDE,
							},
						});
					} else {
						message.error({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => POST_CATCH())
				.finally(() => this.setState({ _publicacoes_loading: false }));
		}, 500);
	};

	onPaginationChangePublicacoes = (page, size) => {
		this.setState({
			_publicacoes_pagination: {
				...this.state._publicacoes_pagination,
				current: page,
				limit: size,
			},
		});
		this.onRenderDataPublicacoes();
	};

	onSearchChangePublicacoes = (e) => {
		this.setState({
			_publicacoes_search: e.target.value,
		});
		this.onRenderDataPublicacoes();
	};

	removePhoto = (ID) => {
		POST_API("/timeline/del_photo.php", { token: getToken(), ID })
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
					this.setState({ _publicacoes_form: res.dados });
					this.onRenderDataPublicacoes();
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				POST_CATCH();
			});
	};

	changePagination = () => {
		this.setState({
			_publicacoes_pagination: {
				...this.state._publicacoes_pagination,
				limit: this.state._publicacoes_pagination.limit + 3,
			},
		});
	};

	onLoadMore = async () => {
		await this.changePagination().then(() => this.onRenderDataPublicacoes());
	};

	// FUNCTION MY PROFILE

	onLoad = () => {
		POST_API("/specialty/search.php", { token: getToken(), type: "list" })
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					this.setState({ special: res.data });
				} else {
					message.error({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => POST_CATCH());
	};

	onView = async () => {
		await POST_API("/credential/search.php", {
			token: getToken(),
			type: "self",
		})
			.then((rs) => rs.json())
			.then((res) => {
				this.setState({ defaultValue: res.data, _screen: false });
				if (String(res.data.LOGIN).length > 14) {
					this.setState({ doc: true });
				}
			})
			.catch(() => POST_CATCH());
	};

	onSend = (values) => {
		this.setState({ _screen: true });
		POST_API("/credential/self-pass.php", {
			token: getToken(),
			master: JSON.stringify(values),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.setState({ _screen: false }));
	};

	onSendAccount = () => {
		this.setState({ _loading: true });
		POST_API("/credential/self-saveall.php", {
			token: getToken(),
			master: JSON.stringify(this.state.defaultValue),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.setState({ _loading: false }));
	};

	onChangePic = (value) => {
		if (value.file.response?.url) {
			this.setState({ _screen: true });
			POST_API("/credential/self-save.php", {
				token: getToken(),
				master: JSON.stringify({ INTER_AVATAR: value.file.response?.url }),
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						message.success({ content: res.msg, key: "screen" });
					} else {
						message.warning({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => {
					message.error({
						content: "Não foi possível estabelecer uma conexão com o sistema",
						key: "screen",
					});
				})
				.finally(() => this.onView());
		}
	};

	onChangePicBanner = (value) => {
		if (value.file.response?.url) {
			this.setState({ _screen: true });
			POST_API("/credential/self-save.php", {
				token: getToken(),
				master: JSON.stringify({ BANNER: value.file.response?.url }),
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						message.success({ content: res.msg, key: "screen" });
					} else {
						message.warning({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => {
					message.error({
						content: "Não foi possível estabelecer uma conexão com o sistema",
						key: "screen",
					});
				})
				.finally(() => this.onView());
		}
	};

	onChangeName = (value) => {
		this.setState({ _screen: true });
		POST_API("/credential/self-save.php", {
			token: getToken(),
			master: JSON.stringify({ NAME: value }),
		})
			.then((rs) => rs.json())
			.then((res) => {
				if (res.return) {
					message.success({ content: res.msg, key: "screen" });
				} else {
					message.warning({ content: res.msg, key: "screen" });
				}
			})
			.catch(() => {
				message.error({
					content: "Não foi possível estabelecer uma conexão com o sistema",
					key: "screen",
				});
			})
			.finally(() => this.onView());
	};

	downloadQRCode = async () => {
		const canvas = await html2canvas(document.getElementById("myqrcode"));
		const dataURL = canvas.toDataURL("image/png");
		downloadjs(dataURL, "download.png", "image/png");
	};

	onCopy = () => {
		window.navigator.clipboard.writeText(
			`https://jurisvip.com.br/advogados/${this.state.defaultValue.ID}`,
		);
		message.success({ content: "URL copiada", key: "screen" });
	};

	onChangeField = (a) => {
		if (a.length > 0) {
			const name = a[0].name[0];
			const value = a[0].value;
			this.setState({
				defaultValue: {
					...this.state.defaultValue,
					[name]: value,
				},
			});
		}
	};

	render = () => {
		if (this.state._navigate) {
			return <Navigate to={"/painel"} />;
		}

		return (
			<Layout>
				<Layout.Content className={"admin-container"}>
					<Row gutter={[8, 8]}>
						<Col span={18}>
							<Breadcrumb items={this.routes} />
						</Col>
						<Col
							span={6}
							style={{ display: "flex", justifyContent: "flex-end" }}
						/>
						{this.state._screen ? (
							<PageLoad />
						) : (
							<>
								<>
									{verifyConfig(["PA", "PC"]) ? null : (
										<Col md={16} xs={24}>
											<Form
												initialValues={this.state.defaultValue}
												layout="vertical"
												onFieldsChange={(a, b) => this.onChangeField(a, b)}
												onFinish={this.onSendAccount}
											>
												<Button
													className="fabbutton btn-primary"
													htmlType="submit"
													shape="circle"
													size="large"
												>
													<IoCheckmark color="#FFF" size={22} />
												</Button>
												<Row gutter={[8, 8]}>
													<Col span={24}>
														<Card bordered size="small" title="Perfil Público">
															<Row gutter={[16, 0]}>
																<Col md={24} xs={24}>
																	<Form.Item
																		label="Especialidade"
																		name="SPECIALITY"
																	>
																		<Select mode="tags">
																			{this.state.special.map((v, i) => (
																				<Select.Option key={i} value={v.NAME}>
																					{v.NAME}
																				</Select.Option>
																			))}
																		</Select>
																	</Form.Item>
																</Col>
																<Col md={24} xs={24}>
																	<Form.Item label="Apresentação" name="DESC">
																		<Input.TextArea
																			className="text-area"
																			maxLength={1000}
																			rows={4}
																			showCount
																			type="text"
																		/>
																	</Form.Item>
																</Col>
																<Col md={24} xs={24}>
																	<Form.Item label="Sobre" name="ABOUT">
																		<Input.TextArea
																			className="text-area"
																			maxLength={1000}
																			rows={4}
																			showCount
																			type="text"
																		/>
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
													<Col span={24}>
														<Card bordered size="small" title="Endereço">
															<Row gutter={[16, 0]}>
																<Col md={6} xs={24}>
																	<Form.Item label="CEP" name="CEP">
																		<ReactInputMask
																			mask={"99999-999"}
																			maskChar={""}
																			maxLength={9}
																			onBlur={this.buscaCEP}
																		>
																			{(props) => <Input {...props} />}
																		</ReactInputMask>
																	</Form.Item>
																</Col>
																<Col md={14} xs={24}>
																	<Form.Item label="Endereço" name="STREET">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={4} xs={24}>
																	<Form.Item label="Número" name="NUMBER">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={10} xs={24}>
																	<Form.Item label="Bairro" name="DISTRICT">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={10} xs={24}>
																	<Form.Item label="Cidade" name="CITY">
																		<Input type="text" />
																	</Form.Item>
																</Col>
																<Col md={4} xs={24}>
																	<Form.Item label="UF" name="STATE">
																		<Input maxLength={2} type="text" />
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
													<Col span={24}>
														<Card bordered size="small" title="Contato">
															<Row gutter={[16, 0]}>
																<Col md={16} xs={24}>
																	<Form.Item label="E-mail" name="EMAIL">
																		<Input
																			addonBefore={<IoMailOutline />}
																			type="email"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Whatsapp" name="WHATSAPP">
																		<ReactInputMask
																			className="ant-input css-dev-only-do-not-override-w8mnev css-w8mnev"
																			mask={"+55 (99) 99999-9999"}
																			maskChar={""}
																			maxLength={19}
																			value={this.state.defaultValue?.WHATSAPP}
																		>
																			{(props) => (
																				<Input
																					{...props}
																					addonBefore={<IoLogoWhatsapp />}
																				/>
																			)}
																		</ReactInputMask>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Instagram" name="INSTAGRAM">
																		<Input
																			addonBefore={<IoLogoInstagram />}
																			placeholder="Colar URL completa"
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Facebook" name="FACEBOOK">
																		<Input
																			addonBefore={<IoLogoFacebook />}
																			placeholder="Colar URL completa"
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="X" name="TWITTER">
																		<Input
																			addonBefore={<FaXTwitter />}
																			placeholder="Colar URL completa"
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="LinkedIn" name="LINKEDIN">
																		<Input
																			addonBefore={<IoLogoLinkedin />}
																			placeholder="Colar URL completa"
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Youtube" name="YOUTUBE">
																		<Input
																			addonBefore={<IoLogoYoutube />}
																			placeholder="Colar URL completa"
																			type="url"
																		/>
																	</Form.Item>
																</Col>
																<Col md={8} xs={24}>
																	<Form.Item label="Site" name="SITE">
																		<Input
																			addonBefore={<IoLinkOutline />}
																			placeholder="Colar URL completa"
																			type="url"
																		/>
																	</Form.Item>
																</Col>
															</Row>
														</Card>
													</Col>
													<Col span={24}>
														<Card bordered size="small">
															<Typography style={{ textAlign: "justify" }}>
																Todos os campos desta página são opcionais e
																podem ser excluídos a qualquer momento e, ao
																preenchê-los, você nos dá consentimento para
																compartilhar esses dados onde quer que seu
																perfil de usuário apareça. Consulte nossa
																declaração de privacidade para saber mais sobre
																como usamos essas informações.
															</Typography>
														</Card>
													</Col>
												</Row>
												{/* LISTA NOSSA EQUIPE */}
												<Divider />
												<Row gutter={[8, 8]}>
													<Col span={24}>
														<Card bordered size="small" title="Nossa Equipe">
															<Row align={"middle"} gutter={[8, 8]}>
																<Col md={20} xs={24}>
																	<Typography style={{ textAlign: "justify" }}>
																		Adicione um membro a sua equipe, para que
																		outros possam ver!
																	</Typography>
																</Col>
																<Col md={4} xs={24}>
																	<Button
																		block
																		className="btn-primary"
																		onClick={() =>
																			this.openModalNossaEquipe("add")
																		}
																		shape="round"
																		size="small"
																		style={{ fontSize: 10 }}
																		type="primary"
																	>
																		NOVO
																	</Button>
																</Col>
																<Col md={0} xs={0} />
																<Col md={24} xs={24}>
																	<Input
																		className="table__form_filter_input"
																		onChange={this.onSearchChangeEquipe}
																		placeholder={"Pesquisar..."}
																		value={this.state._equipe_search}
																	/>
																</Col>
																{this.state._equipe_loading ? (
																	<Col span={24}>
																		<center>
																			<Spin />
																		</center>
																	</Col>
																) : (
																	<>
																		{this.state._equipe_list.length > 0 ? (
																			<Col span={24}>
																				<List
																					dataSource={this.state._equipe_list}
																					itemLayout="horizontal"
																					renderItem={(item, index) => (
																						<List.Item
																							actions={[
																								<Button
																									className="table__btn table__btn_edit"
																									onClick={() =>
																										this.openModalNossaEquipe(
																											"edit",
																											item,
																										)
																									}
																									shape="circle"
																									size="small"
																									title="Editar"
																									type="primary"
																								>
																									<IoPencil size={14} />
																								</Button>,
																								<Button
																									className="table__btn table__btn_delete"
																									onClick={() =>
																										this.onActionEquipe(
																											item.ID,
																											"del",
																											"Excluir registro?",
																										)
																									}
																									shape="circle"
																									size="small"
																									title="Excluir"
																									type="primary"
																								>
																									<IoTrash size={14} />
																								</Button>,
																							]}
																							key={index}
																						>
																							<List.Item.Meta
																								avatar={
																									<Avatar
																										size={50}
																										src={item.AVATAR}
																									/>
																								}
																								description={
																									<Typography
																										style={{
																											textAlign: "justify",
																										}}
																									>
																										{item.DESC}
																									</Typography>
																								}
																								title={
																									<Typography>
																										{item.NAME}
																									</Typography>
																								}
																							/>
																						</List.Item>
																					)}
																				/>
																			</Col>
																		) : (
																			<Col span={24}>
																				<Typography className="no-data">
																					Nenhum item encontrado
																				</Typography>
																			</Col>
																		)}
																	</>
																)}
																<Col span={24}>
																	<center>
																		<Pagination
																			current={
																				this.state._equipe_pagination.current
																			}
																			defaultCurrent={
																				this.state._equipe_pagination.current
																			}
																			onChange={this.onPaginationChangeEquipe}
																			pageSize={
																				this.state._equipe_pagination.limit
																			}
																			size="small"
																			total={
																				this.state._equipe_pagination.total
																			}
																		/>
																	</center>
																</Col>
															</Row>
														</Card>
													</Col>
												</Row>
												{/* LISTA CLIENTES */}
												<Divider />
												<Row gutter={[8, 8]}>
													<Col span={24}>
														<Card bordered size="small" title="Clientes">
															<Row align={"middle"} gutter={[8, 8]}>
																<Col md={20} xs={24}>
																	<Typography style={{ textAlign: "justify" }}>
																		Adicione um cliente a sua lista de clientes,
																		para que outros possam ver!
																	</Typography>
																</Col>
																<Col md={4} xs={24}>
																	<Button
																		block
																		className="btn-primary"
																		onClick={() => this.openModalCliente("add")}
																		shape="round"
																		size="small"
																		style={{ fontSize: 10 }}
																		type="primary"
																	>
																		NOVO
																	</Button>
																</Col>
																<Col md={0} xs={0} />
																<Col md={24} xs={24}>
																	<Input
																		className="table__form_filter_input"
																		onChange={this.onSearchChangeCliente}
																		placeholder={"Pesquisar..."}
																		value={this.state._cliente_search}
																	/>
																</Col>
																{this.state._cliente_loading ? (
																	<Col span={24}>
																		<center>
																			<Spin />
																		</center>
																	</Col>
																) : (
																	<>
																		{this.state._cliente_list.length > 0 ? (
																			<Col span={24}>
																				<List
																					dataSource={this.state._cliente_list}
																					itemLayout="horizontal"
																					renderItem={(item, index) => (
																						<List.Item
																							actions={[
																								<Button
																									className="table__btn table__btn_edit"
																									onClick={() =>
																										this.openModalCliente(
																											"edit",
																											item,
																										)
																									}
																									shape="circle"
																									size="small"
																									title="Editar"
																									type="primary"
																								>
																									<IoPencil size={14} />
																								</Button>,
																								<Button
																									className="table__btn table__btn_delete"
																									onClick={() =>
																										this.onActionCliente(
																											item.ID,
																											"del",
																											"Excluir registro?",
																										)
																									}
																									shape="circle"
																									size="small"
																									title="Excluir"
																									type="primary"
																								>
																									<IoTrash size={14} />
																								</Button>,
																							]}
																							key={index}
																						>
																							<List.Item.Meta
																								avatar={
																									<Avatar
																										size={50}
																										src={item.AVATAR}
																									/>
																								}
																								description={
																									<Typography
																										style={{
																											textAlign: "justify",
																										}}
																									>
																										{item.DESC}
																									</Typography>
																								}
																								title={
																									<Typography>
																										{item.NAME}
																									</Typography>
																								}
																							/>
																						</List.Item>
																					)}
																				/>
																			</Col>
																		) : (
																			<Col span={24}>
																				<Typography className="no-data">
																					Nenhum item encontrado
																				</Typography>
																			</Col>
																		)}
																	</>
																)}
																<Col span={24}>
																	<center>
																		<Pagination
																			current={
																				this.state._cliente_pagination.current
																			}
																			defaultCurrent={
																				this.state._cliente_pagination.current
																			}
																			onChange={this.onPaginationChangeCliente}
																			pageSize={
																				this.state._cliente_pagination.limit
																			}
																			size="small"
																			total={
																				this.state._cliente_pagination.total
																			}
																		/>
																	</center>
																</Col>
															</Row>
														</Card>
													</Col>
												</Row>
												{/* LISTA PUBLICAÇÕES */}
												<Divider />
												<Row gutter={[8, 8]}>
													<Col span={24}>
														<Card
															bordered
															size="small"
															title="Faça uma publicação"
														>
															<Row align={"middle"} gutter={[16, 16]}>
																<Col md={20} xs={24}>
																	<Typography style={{ textAlign: "justify" }}>
																		Adicione uma publicação em seu perfil, para
																		que outros possam ver!
																	</Typography>
																</Col>
																<Col md={4} xs={24}>
																	<Button
																		block
																		className="btn-primary"
																		onClick={() =>
																			this.openModalPublicacoes("add")
																		}
																		shape="round"
																		size="small"
																		style={{ fontSize: 10 }}
																		type="primary"
																	>
																		NOVO
																	</Button>
																</Col>
																<Col md={0} xs={0} />
																<Col md={24} xs={24}>
																	<Input
																		className="table__form_filter_input"
																		onChange={this.onSearchChangePublicacoes}
																		placeholder={"Pesquisar..."}
																		value={this.state._publicacoes_search}
																	/>
																</Col>
																{this.state._publicacoes_loading ? (
																	<Col span={24}>
																		<center>
																			<Spin />
																		</center>
																	</Col>
																) : (
																	<>
																		{this.state._publicacoes_list.length > 0 ? (
																			<>
																				{this.state._publicacoes_list.map(
																					(item, index) => (
																						<Col key={index} span={24}>
																							<TimelineComponent
																								index={index}
																								item={item}
																								onActionPublicacoes={
																									this.onActionPublicacoes
																								}
																								onRenderDataPublicacoesLoad={
																									this
																										.onRenderDataPublicacoesLoad
																								}
																								openModalPublicacoes={
																									this.openModalPublicacoes
																								}
																							/>
																						</Col>
																					),
																				)}
																			</>
																		) : (
																			<Col span={24}>
																				<Typography className="no-data">
																					Nenhum item encontrado
																				</Typography>
																			</Col>
																		)}
																	</>
																)}
																{this.state._publicacoes_pagination.limit <
																this.state._publicacoes_pagination.total ? (
																	<Col span={24}>
																		<center>
																			<Button
																				className="btn-default"
																				onClick={this.onLoadMore}
																				type="default"
																			>
																				Carregar mais
																			</Button>
																		</center>
																	</Col>
																) : null}
															</Row>
														</Card>
													</Col>
												</Row>
											</Form>
										</Col>
									)}
									<Col md={8} xs={24}>
										<Row gutter={[8, 8]}>
											<Col span={24}>
												<Card bordered size="small" style={{ paddingTop: 20 }}>
													<Row
														align={"middle"}
														justify="center"
														style={{ flexDirection: "column" }}
													>
														<Avatar
															shape="circle"
															size={200}
															src={this.state.defaultValue.INTER_AVATAR}
															style={{ marginBottom: 12 }}
														/>
														<ImgCrop rotationSlider>
															<Upload
																accept="image/jpg,image/jpeg,image/png"
																action={getUPLOADAPI}
																className={"admin-profile-upload"}
																maxCount={1}
																onChange={this.onChangePic}
																showUploadList={false}
															>
																<Button
																	className="btn-nav"
																	shape="circle"
																	type="default"
																>
																	<IoCameraOutline size={20} />
																</Button>
															</Upload>
														</ImgCrop>
														<Typography.Paragraph
															className={"admin-profile-name"}
															editable={{
																tooltip: false,
																onChange: this.onChangeName,
															}}
														>
															{this.state.defaultValue.NAME}
														</Typography.Paragraph>
													</Row>
												</Card>
											</Col>
											<Col span={24}>
												<Card bordered size="small" title="Banner">
													<Row
														align={"middle"}
														justify="center"
														style={{ flexDirection: "column" }}
													>
														<Image
															preview={false}
															src={this.state.defaultValue.BANNER}
															style={{ borderRadius: 8, marginBottom: 12 }}
															width={"100%"}
														/>
														<Upload
															accept="image/jpg,image/jpeg,image/png"
															action={getUPLOADAPI}
															className={"admin-profile-upload"}
															maxCount={1}
															onChange={this.onChangePicBanner}
															showUploadList={false}
														>
															<Button
																className="btn-nav"
																shape="circle"
																type="default"
															>
																<IoCameraOutline size={20} />
															</Button>
														</Upload>
													</Row>
												</Card>
											</Col>
											{verifyConfig(["PA", "PC"]) ? null : (
												<Col span={24}>
													<Card
														bordered
														size="small"
														title="Compartilhar Perfil"
													>
														<Row
															align={"middle"}
															gutter={[8, 8]}
															justify="center"
															style={{ flexDirection: "column" }}
														>
															<Col id="myqrcode" span={24}>
																<QRCode
																	icon={logo}
																	size={200}
																	value={`https://jurisvip.com.br/advogados/${this.state.defaultValue.ID}`}
																/>
															</Col>
															<Col span={24}>
																<Button
																	onClick={this.downloadQRCode}
																	shape="round"
																	type="primary"
																>
																	Download
																</Button>
															</Col>
															<Col span={24}>
																<Typography style={{ textAlign: "center" }}>
																	https://jurisvip.com.br/advogados/
																	{this.state.defaultValue.ID}
																</Typography>
																<center>
																	<Button
																		className="btn-link"
																		onClick={this.onCopy}
																		shape="round"
																		type="link"
																	>
																		Copiar URL
																	</Button>
																</center>
															</Col>
														</Row>
													</Card>
												</Col>
											)}
										</Row>
									</Col>
								</>
							</>
						)}
					</Row>
					{/* MODAL NOSSA EQUIPE */}
					<Modal
						closable={false}
						destroyOnClose={true}
						footer={false}
						open={this.state._equipe_modal}
						title={this.state._equipe_type === "add" ? "Novo" : "Atualizar"}
					>
						<Divider style={{ margin: 0, marginBottom: 10 }} />
						<Form
							initialValues={this.state._equipe_form}
							layout="vertical"
							onFinish={this.onSaveEquipe}
						>
							<Row gutter={[48, 0]}>
								<Form.Item hidden name="ID">
									<Input />
								</Form.Item>
								<Col span={24}>
									<Form.Item
										label="Nome"
										name="NAME"
										rules={[{ required: true, message: "Campo obrigatório!" }]}
									>
										<Input />
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item
										label="Descrição"
										name="DESC"
										rules={[{ required: true, message: "Campo obrigatório!" }]}
									>
										<Input.TextArea maxLength={1000} rows={4} showCount />
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item label="Foto" name="AVATAR">
										<Upload
											accept="image/png,image/jpeg"
											action={getUPLOADAPI}
											className="upload-list-inline"
											listType="picture"
											maxCount={1}
										>
											<Button icon={<IoCloudUploadOutline />}>Upload</Button>
										</Upload>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item>
										<Button
											block
											className="btn-default"
											loading={this.state._equipe_loading}
											onClick={this.closeModalNossaEquipe}
											shape="round"
											type="default"
										>
											Fechar
										</Button>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item>
										<Button
											block
											className="btn-primary"
											htmlType="submit"
											loading={this.state._equipe_loading}
											shape="round"
											type="primary"
										>
											Salvar
										</Button>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</Modal>
					{/* MODAL CLIENTE */}
					<Modal
						closable={false}
						destroyOnClose={true}
						footer={false}
						open={this.state._cliente_modal}
						title={this.state._cliente_type === "add" ? "Novo" : "Atualizar"}
					>
						<Divider style={{ margin: 0, marginBottom: 10 }} />
						<Form
							initialValues={this.state._cliente_form}
							layout="vertical"
							onFinish={this.onSaveCliente}
						>
							<Row gutter={[48, 0]}>
								<Form.Item hidden name="ID">
									<Input />
								</Form.Item>
								<Col span={24}>
									<Form.Item
										label="Nome"
										name="NAME"
										rules={[{ required: true, message: "Campo obrigatório!" }]}
									>
										<Input />
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item
										label="Descrição"
										name="DESC"
										rules={[{ required: true, message: "Campo obrigatório!" }]}
									>
										<Input.TextArea maxLength={1000} rows={4} showCount />
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item label="Foto" name="AVATAR">
										<Upload
											accept="image/png,image/jpeg"
											action={getUPLOADAPI}
											className="upload-list-inline"
											listType="picture"
											maxCount={1}
										>
											<Button icon={<IoCloudUploadOutline />}>Upload</Button>
										</Upload>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item>
										<Button
											block
											className="btn-default"
											loading={this.state._cliente_loading}
											onClick={this.closeModalCliente}
											shape="round"
											type="default"
										>
											Fechar
										</Button>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item>
										<Button
											block
											className="btn-primary"
											htmlType="submit"
											loading={this.state._cliente_loading}
											shape="round"
											type="primary"
										>
											Salvar
										</Button>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</Modal>
					{/* MODAL PUBLICAÇÕES */}
					<Modal
						closable={false}
						destroyOnClose={true}
						footer={false}
						open={this.state._publicacoes_modal}
						title={
							this.state._publicacoes_type === "add" ? "Novo" : "Atualizar"
						}
					>
						<Divider style={{ margin: 0, marginBottom: 10 }} />
						<Form
							initialValues={this.state._publicacoes_form}
							layout="vertical"
							onFinish={this.onSavePublicacoes}
						>
							<Row gutter={[48, 0]}>
								<Form.Item hidden name="ID">
									<Input />
								</Form.Item>
								<Col span={24}>
									<Form.Item
										label="Título"
										name="NAME"
										rules={[{ required: true, message: "Campo obrigatório!" }]}
									>
										<Input />
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item
										label="Descrição"
										name="DESC"
										rules={[{ required: true, message: "Campo obrigatório!" }]}
									>
										<Input.TextArea maxLength={1000} rows={4} showCount />
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item label="Imagens" name="PHOTOS">
										<Upload
											accept="image/png,image/jpeg"
											action={getUPLOADAPI}
											className="upload-list-inline"
											listType="picture"
											multiple
										>
											<Button icon={<IoCloudUploadOutline />}>Upload</Button>
										</Upload>
									</Form.Item>
								</Col>
								<Col span={24} style={{ marginBottom: 10, marginTop: -24 }}>
									<div className="ant-upload-wrapper upload-list-inline css-dev-only-do-not-override-w8mnev css-w8mnev">
										<div className="ant-upload-list ant-upload-list-picture">
											{this.state._publicacoes_form?.PHOTOS.map((v) => (
												<div
													className="ant-upload-list-item-container"
													key={v.ID}
												>
													<div className="ant-upload-list-item ant-upload-list-item-done">
														<a
															className="ant-upload-list-item-thumbnail"
															href={v.URL}
															rel="noopener noreferrer"
															target="_blank"
														>
															{/** biome-ignore lint/performance/noImgElement: img */}
															<img
																alt={v.NAME}
																className="ant-upload-list-item-image"
																src={v.URL}
																width={"100%"}
															/>
														</a>
														<span
															className="ant-upload-list-item-name"
															title={v.NAME}
														>
															{v.NAME}
														</span>
														<span className="ant-upload-list-item-actions picture">
															<button
																className="ant-btn css-dev-only-do-not-override-w8mnev ant-btn-text ant-btn-sm ant-btn-icon-only ant-upload-list-item-action"
																onClick={() => this.removePhoto(v.ID)}
																title="Remove file"
																type="button"
															>
																<span className="ant-btn-icon">
																	<span
																		aria-label="delete"
																		className="anticon anticon-delete"
																		role="img"
																		tabindex="-1"
																	>
																		<svg
																			aria-hidden="true"
																			data-icon="delete"
																			fill="currentColor"
																			focusable="false"
																			height="1em"
																			viewBox="64 64 896 896"
																			width="1em"
																		>
																			<path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" />
																		</svg>
																	</span>
																</span>
															</button>
														</span>
													</div>
												</div>
											))}
										</div>
									</div>
								</Col>
								<Col span={12}>
									<Form.Item>
										<Button
											block
											className="btn-default"
											loading={this.state._publicacoes_loading}
											onClick={this.closeModalPublicacoes}
											shape="round"
											type="default"
										>
											Fechar
										</Button>
									</Form.Item>
								</Col>
								<Col span={12}>
									<Form.Item>
										<Button
											block
											className="btn-primary"
											htmlType="submit"
											loading={this.state._publicacoes_loading}
											shape="round"
											type="primary"
										>
											Salvar
										</Button>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</Modal>
				</Layout.Content>
			</Layout>
		);
	};
}

export default AdminMeuPerfil;
